import AllRecord from './all-record'

const MyRecord = () => {
  return <AllRecord showMyRecord={true} />
}

export default MyRecord
